import $ from 'jquery'

$(document).ready(function() {
	//Minor twist to align elements better!
	if (!$('#internal-nav').length) {
		/**
		 * With the stack class, the content page will aligned with
		 * the header and footer in large screen.
		 */
		$('.innerpage-layout').addClass('stack')
	}
})
